export var ApiUrls;
(function (ApiUrls) {
    ApiUrls["Deals"] = "/v1/deals";
})(ApiUrls || (ApiUrls = {}));
